"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _configuration = require("../configuration");

var _default = function _default(pluginManager) {
  var BaseAssemblyConfigSchema = (0, _configuration.ConfigurationSchema)('BaseAssembly', {
    aliases: {
      type: 'stringArray',
      defaultValue: [],
      description: 'Other possible names for the assembly'
    },
    sequence: pluginManager.getTrackType('ReferenceSequenceTrack').configSchema,
    refNameColors: {
      type: 'stringArray',
      defaultValue: [],
      description: 'Define custom colors for each reference sequence. Will cycle through this list if there are not enough colors for every sequence.'
    }
  }, {
    explicitIdentifier: 'name'
  });
  var AssemblyConfigSchema = (0, _configuration.ConfigurationSchema)('Assembly', {
    refNameAliases: (0, _configuration.ConfigurationSchema)('RefNameAliases', {
      adapter: pluginManager.pluggableConfigSchemaType('adapter')
    })
  }, {
    baseConfiguration: BaseAssemblyConfigSchema
  });

  function dispatcher(snapshot) {
    if (!snapshot) {
      return BaseAssemblyConfigSchema;
    }

    var refNameAliases = snapshot.refNameAliases;

    if (refNameAliases) {
      return AssemblyConfigSchema;
    }

    return BaseAssemblyConfigSchema;
  }

  return {
    assemblyConfigSchemas: [AssemblyConfigSchema, BaseAssemblyConfigSchema],
    dispatcher: dispatcher
  };
};

exports.default = _default;